// TODO replace axios get
import axios from 'axios'

const CURRENT_ADDRESS_ENDPOINT = 'https://nominatim.openstreetmap.org/reverse'
const ADDRESS_COORDS_ENDPOINT = 'https://nominatim.openstreetmap.org/search'
const FORMAT = 'jsonv2'

export function currentCoordinates() {
  if (navigator.geolocation) {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        ({ coords }) => resolve(coords),
        // Reject if the user doesn't allow access
        error => reject(error),
      )
    })
  }
}

export async function addressByCoordinates({ latitude, longitude }) {
  const { data } = await axios.get(CURRENT_ADDRESS_ENDPOINT, {
    params: {
      format: FORMAT,
      lat: latitude,
      lon: longitude,
    },
  })

  return data.address
}

export async function coordinatesByAddress(city, state) {
  const { data } = await axios.get(ADDRESS_COORDS_ENDPOINT, {
    params: {
      format: FORMAT,
      city,
      state,
    },
  })
  const bestMatch = await [data[0].lat, data[0].lon]
  return bestMatch
}

export async function currentAddress() {
  const coordinates = await currentCoordinates()

  return addressByCoordinates(coordinates)
}
